import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import "./Stats.css";

const Stats = ({
  numberVlogs,
  numberQuestions,
  numberTopics,
  numberArchitecture,
}) => {
  const ref = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (!hasAnimated) {
            setHasAnimated(true);
          }
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasAnimated]);

  // אנימציות שמבוססות על אם האלמנט נצפה לראשונה
  const vlogsAnim = useSpring({
    number: hasAnimated ? numberVlogs : 0,
    from: { number: 0 },
    delay: 1000,
    config: { tension: 200, friction: 20 },
  });

  const questionsAnim = useSpring({
    number: hasAnimated ? numberQuestions : 0,
    from: { number: 0 },
    delay: 1000,
    config: { tension: 200, friction: 20 },
  });

  const topicsAnim = useSpring({
    number: hasAnimated ? numberTopics : 0,
    from: { number: 0 },
    delay: 1000,
    config: { tension: 200, friction: 20 },
  });

  const architectureAnim = useSpring({
    number: hasAnimated ? numberArchitecture : 0,
    from: { number: 0 },
    delay: 1000,
    config: { tension: 200, friction: 20 },
  });

  // אנימציה של הגדלה והקטנה
  const scaleAnim = useSpring({
    to: { transform: hasAnimated ? "scale(1.05)" : "scale(1)" },
    from: { transform: "scale(1)" },
    reset: true,
    reverse: hasAnimated,
    config: { tension: 250, friction: 25 },
    loop: true,
  });

  return (
    <>
      <div ref={ref} className="stats-container">
        <Link
          to="/VlogListAllVlogs"
          className={`stat-box text-decoration-none ${
            isVisible ? "visible" : ""
          }`}
        >
          <animated.div
            className="stat-number n-color-purple"
            style={scaleAnim}
          >
            {vlogsAnim.number.to((n) => n.toFixed(0))}
          </animated.div>
          <p>וולוגים</p>
        </Link>
        <Link
          to="/VlogListLeetCode"
          className={`stat-box text-decoration-none ${
            isVisible ? "visible" : ""
          }`}
        >
          <animated.div
            className="stat-number n-color-purple"
            style={scaleAnim}
          >
            {questionsAnim.number.to((n) => n.toFixed(0))}
          </animated.div>
          <p>LeetCode</p>
        </Link>
        {/*
        <Link
          to="/VlogListTechnologyTopics"
          className="stat-box text-decoration-none"
        >
          <animated.div
            className="stat-number n-color-purple"
            style={scaleAnim}
          >
            {topicsAnim.number.to((n) => n.toFixed(0))}
          </animated.div>
          <p className="n-color-purple ">נושאים טכנולגיים</p>
        </Link>
        */}
        <Link
          to="/VlogListCodeArchitecture"
          className={`stat-box text-decoration-none ${
            isVisible ? "visible" : ""
          }`}
        >
          <animated.div
            className="stat-number n-color-purple"
            style={scaleAnim}
          >
            {architectureAnim.number.to((n) => n.toFixed(0))}
          </animated.div>
          <p>ארכיטקטורת קוד</p>
        </Link>
      </div>
    </>
  );
};

export default Stats;
